import { documentsConfiguration } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";

function isValid(name: string): boolean {
	const { webDav } = documentsConfiguration();

	if (!webDav) {
		throw new Error("WebDav is not configured");
	}

	const { illegalCharacters } = webDav;
	return illegalCharacters.every(c => name.indexOf(c) < 0);
}

export {
	isValid
};
